export const editableItemsStyles = {
  padding: 5,
  height: '28px',
  display: 'flex',
  alignItems: 'center',
};
